import mutations from './eesztLogins.mutations'
import actions from './eesztLogins.actions'
import getters from './eesztLogins.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
